import zhLocale from "element-ui/lib/locale/lang/zh-CN";
const cn = {
  // 单词类
  "登录": "登录",
  "公司": "公司",
  "主页": "主页",
  "设定": "设定",
  "努力加载中":"努力加载中",
  "全部":"全部",
  "所有记录":"所有记录",
  "海关报表":"海关报表",
  "客户记录":"客户记录",
  "会员管理": "会员管理",
  "资金管理":"资金管理",
  "资金结余":"资金结余",
  "账户管理":"账户管理",
  "设定汇率":"设定汇率",
  "小票设定":"小票设定",
  "权限管理":"权限管理",
  "账号管理":"账号管理",
  "兑换买入":"兑换买入",
  "兑换卖出":"兑换卖出",
  "货币汇款":"货币汇款",
  "现金结余": "现金结余",
  "银行结余": "银行结余",
  "设置汇率":"设置汇率",
  "":"",



  // element多语言
  ...zhLocale
}

export default cn
